export default "__VITE_ASSET__BYUhZ0B$__"